<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div>
    <div
      class="d-flex  align-center justify-center pa-2 flex-column"
    >
      <v-card
        class="text-center pa-1"
        elevation="0"
        max-width="400px"
        width="100%"
      >
        <v-card-title class="justify-center text-h4 mb-2">
          {{ $t('OptionalLicense') }}
        </v-card-title>
        <v-card-subtitle>
          {{ !isAddition ? $t('StartSubscribe') : $t('ChooseSelectedAbo') }}
        </v-card-subtitle>
        <v-card-text class="mt-4">
          <template v-if="!loading">
            <template v-if="!isAddition">
              <div
                style="display: grid;grid-template-columns: repeat(2,1fr);grid-gap: 16px"
              >
                <v-card
                  v-for="p in displayProducts"
                  :key="p.id"
                  class="pa-2 d-flex flex-column"
                  elevation="1"
                  @click="createPayment(p.prices[0].id)"
                >
                  <div class="font-weight-bold text-body-1">
                    {{ p.name }}
                  </div>
                  <div class="mt-2">
                    <div>
                      {{ p.description }}
                    </div>
                  </div>
                  <div class="mt-1 font-weight-bold">
                    {{ p.prices[0].unit_amount / 100 }} €/{{ $t('Monthly') }}
                  </div>
                </v-card>
              </div>
            </template>
            <template v-else>
              <div>
                <v-card
                  v-for="p in displayProducts"
                  :key="p.id"
                  class="pa-4 d-flex flex-column align-center"
                  elevation="0"
                >
                  <div class="font-weight-bold text-h4">
                    {{ p.name }}
                  </div>
                  <div class="mt-3">
                    <div>
                      {{ p.description }}
                    </div>
                  </div>
                  <div class="font-weight-bold mt-1">
                    {{ p.prices[0].unit_amount * licenseCount / 100 | priceDisplay }}/{{ $t('Monthly') }}
                  </div>
                  <div
                    class="mt-1 d-flex align-center"
                    style="width: 108px"
                  >
                    <v-btn
                      icon
                      large
                      @click="licenseCount>1?licenseCount--:null"
                    >
                      <v-icon>mdi-minus-circle</v-icon>
                    </v-btn>
                    <h4 class="flex-grow-1">
                      {{ licenseCount }}
                    </h4>
                    <v-btn
                      icon
                      large
                      @click="licenseCount++"
                    >
                      <v-icon>mdi-plus-circle</v-icon>
                    </v-btn>
                  </div>
                </v-card>
              </div>
            </template>
          </template>
          <template v-else>
            <div
              class="d-flex flex-column align-center justify-center"
              style="height: 240px;"
            >
              <v-progress-circular indeterminate />
            </div>
          </template>
          <div
            v-if="isAddition"
            class="py-2 px-1"
          >
            <v-btn
              :loading="loading"
              block
              class="mt-3"
              color="success"
              elevation="0"
              large
              @click="createPayment(displayProducts[0].prices[0].id)"
            >
              <v-icon left>
                mdi-check
              </v-icon>
              {{ $t('CartCheckout') }}
            </v-btn>
            <v-btn
              :loading="loading"
              block
              class="mt-2 amber"
              elevation="0"
              large
              @click="$emit('closeDialog')"
            >
              <v-icon left>
                mdi-arrow-left
              </v-icon>
              {{ $t('Cancel') }}
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>

import { loadProducts } from '@/model/dataLayer/api/SaaS/product'
import { createCheckoutSession } from 'firestore-stripe-payments-jhd'
import { StripePayment } from '@/model/firebase/google-fire-base'
import { mapState } from 'vuex'

export default {
  name: 'AddSubscriptionPage',
  components: {},
  props: {
    addProductName: {}
  },
  data: function () {
    return {
      products: [],
      licenseCount: 1,
      loading: false
    }
  },
  async mounted () {
    this.products = await loadProducts()
    this.licenseCount = 1
  },
  computed: {
    isAddition () {
      return this.license.length !== 0
    },
    ...mapState(['license']),
    displayProducts () {
      if (this.license.length !== 0) {
        return this.products.filter(it => it.additional === this.isAddition && it.name === this.addProductName)
      } else {
        return this.products.filter(it => it.additional === this.isAddition)
      }
    }
  },
  methods: {
    async createPayment (priceId) {
      this.loading = true
      const session = await createCheckoutSession(StripePayment, {
        line_items: [
          {
            price: priceId,
            quantity: this.licenseCount
          }
        ],
        payment_method_types: ['card', 'sepa_debit'],
        allow_promotion_codes: true

      }, { timeoutMillis: 60 * 1000 })
      this.loading = false
      window.location.assign(session.url)
    }
  }
}
</script>

<style scoped>

</style>
